@if (loaded) {
    <swiper-container #swiperRef [attr.aria-busy]="activeSlideIndex ? 'true' : null">
        @for (item of items; track manager?.getSource().getItemId(item); let index = $index) {
            <swiper-slide [attr.aria-hidden]="!isActive(index)" [attr.tabindex]="!isActive(index) ? -1 : null">
                @if (template) {
                    <ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{item: item, active: isActive(index)}" />
                }
            </swiper-slide>
        }
    </swiper-container>
}
